import c from "../common";

export default {
  sender: "轉讓人",
  receiver: "接收人",
  senderEmail: "轉讓人電郵",
  senderName: "轉讓人姓名",
  senderTel: "轉讓人電話",
  receiverEmail: "接收人電郵",
  receiverName: "接收人姓名",
  receiverTel: "接收人電話",
  point: "積分",

  description_1: "搜索",
  description_2: "的 轉讓記錄",
  description_3: "搜索記錄",
  description_4: "選擇日期",
  description_5: "重設",
  description_6: "搜索",
  description_7: "最近7日",
  description_8: "最近30日",
  description_9: "自訂",
  description_10: "選擇" + c.voucher.chn + " (optional)",
  description_11: "全選",
  description_12: "清除所選",
  description_13: "到期日",
  description_14: "已選擇",
  description_15: "暫無可選",
  description_16: "請選擇日期範圍",
  
};
